import { render, staticRenderFns } from "./exclusive.vue?vue&type=template&id=2565ccd6&"
import script from "./exclusive.vue?vue&type=script&lang=js&"
export * from "./exclusive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports